<template>
  <div class="pb-2">
    <b-row class="mb-4 mr-1 ml-1">
      <b-col
        xs="12"
        sm="12"
        md="12"
        lg="4"
        xl="4"
        class="d-flex justify-content-center"
      >
        <slot name="leftSide"></slot>
      </b-col>

      <b-col xs="12" sm="12" md="12" lg="4" xl="4" class="">
        <b-input-group
          size="sm"
          class="shadows rounded-right rounded-left align-middle bg-purple-blue"
        >
          <b-form-input
            class="filter-input rounded-right rounded-left"
            v-model="filter"
            type="search"
            id="filterInput"
            @change="getDataFilter()"
          ></b-form-input>
          <b-input-group-append class="rounded-right rounded-left">
            <b-icon
              icon="search"
              variant="pink"
              class="h5 m-2 align-middle"
            ></b-icon>
          </b-input-group-append>
        </b-input-group>
      </b-col>

      <b-col xs="12" sm="12" md="12" lg="4" xl="4" class="text-center">
        <slot name="rightSide"></slot>
      </b-col>
    </b-row>
    <div class="container-fluid">
      <b-table
        thead-class="text-center bg-light-grey "
        head-variant="light"
        bordered
        small
        show-empty
        outlined
        stacked="md"
        :fields="fields"
        :items="items.data"
        id="tableMain"
        :busy="busy"
        class="text-break"
      >
        <template #empty>
          <div class="text-center">
            <h6>No records</h6>
          </div>
        </template>
        <template #table-busy>
          <div class="text-center text-purple-blue my-2">
            <b-spinner variant="purple-blue" class="align-middle"></b-spinner>
            <p>Loading</p>
          </div>
        </template>
        <template #cell(selected)="{ item }">
          <div class="d-flex justify-content-center">
            <b-form-checkbox @change="(val) => onRowSelected(val, item)" />
          </div>
        </template>
        <template #cell(createdAt)="{ item }">
          <div>
            {{ item.createdAt | formatDateTime }}
          </div>
        </template>
        <template v-slot:cell(actions)="row">
          <div class="text-center">
            <b-form-group>
              <b-icon
                v-if="row.field.telephone"
                icon="telephone"
                class="h5 m-2"
              ></b-icon>
              <b-icon
                v-if="row.field.mail"
                icon="envelope"
                class="h5 m-2"
              ></b-icon>
              <b-icon
                v-if="row.field.validation"
                icon="card-checklist"
                title="Validations"
                class="h5 m-2"
                @click="openValidationModal(row.item, options.fun)"
              ></b-icon>
              <b-icon
                v-if="row.field.details"
                v-b-tooltip.hover
                title="Details"
                icon="eye"
                class="h5 m-2"
                @click="editItem(row.item)"
              ></b-icon>
              <b-icon
                v-b-tooltip.hover
                title="Delete"
                v-if="row.field.delete"
                :icon="row.item.status !== 1 ? 'toggle-off' : 'toggle-on'"
                class="h5 m-2"
                @click="
                  row.item.status !== 1
                    ? activateItem(row.item)
                    : deleteItem(row.item)
                "
              ></b-icon>
              <b-icon
                v-if="row.field.update"
                icon="pencil"
                class="h5 m-2"
                @click="updateItem(row.item)"
              ></b-icon>
            </b-form-group>
          </div>
        </template>
      </b-table>

      <b-row>
        <b-col
          xs="12"
          sm="12"
          md="12"
          lg="12"
          xl="12"
          class="d-flex justify-content-between"
        >
          <span>
            <p v-show="itemsSelected.length > 0">
              Selected: {{ itemsSelected.length }}
            </p>
          </span>
          <b-pagination
            v-model="table.currentPage"
            :total-rows="table.totalRows"
            :per-page="table.perPage"
            @change="changePage($event)"
            class="mb-2"
          ></b-pagination>
        </b-col>
      </b-row>
    </div>
    <ValidationModal />
  </div>
</template>
<script>
import { generalMixin } from "@/modules/mixin.js";
import { SET_COMPANY_EMAIL } from "./validation/actions";
import store from "@/store";
import ValidationModal from "@/modules/shared/validation/validationModal.vue";
import { validationMixin } from "@/modules/shared/validation/mixin.js";

export default {
  mixins: [generalMixin, validationMixin],
  components: { ValidationModal },
  props: {
    fields: Array,
    items: {},
    options: {},
    selectable: Boolean,
    busy: Boolean,
  },
  data() {
    return {
      filter: null,
      roles: [
        { text: "agent", value: 1 },
        { text: "representative", value: 2 },
      ],
      roleSelected: null,
      itemsSelected: [],
    };
  },
  computed: {
    table() {
      return {
        totalRows: this.items.total,
        currentPage: this.items.currentPage,
        perPage: this.items.perPage,
      };
    },
  },
  methods: {
    deleteItem(item) {
      this.$parent.deleteItem(item);
    },
    editItem(item) {
      this.$parent.editItem(item);
    },
    activateItem(item) {
      this.$parent.activateItem(item);
    },
    showModal() {
      this.$parent.$refs[store.state.general.modalId].show();
    },
    updateItem(item) {
      this.$parent.updateItem(item);
    },
    openValidationModal(item, fun) {
      this.$store.commit("setReady", false);

      if (fun) {
        this.$store.commit("setRefreshData", fun);
      }

      this.$store.commit("setItemUser", item);

      this.$store.commit(SET_COMPANY_EMAIL, item.user.email);

      this.$bvModal.show("validation-modal");
    },
    changePage(page) {
      this.$parent.changePage(page);
    },
    getDataFilter() {
      this.$parent.getData(this.filter);
    },
    onRowSelected(val, item) {
      if (val) {
        this.itemsSelected.push(item);
      } else {
        const index = this.itemsSelected.indexOf(item);
        this.itemsSelected.splice(index, 1);
      }
      this.$parent.getSelectedItems([...this.itemsSelected]);
    },
  },
};
</script>
<style lang="scss" scoped>
.filter-input {
  background-color: #12144a;
  opacity: 1;
  color: white;
  border: none;
}
.form-control:focus {
  background-color: #12144a;
  color: white;
  border-color: #12144a;
}
.shadows {
  box-shadow: 0 7px 7px 0 rgba(0, 0, 0, 0.5);
}
</style>
